import { House, SearchX, Car } from "lucide-react";
import { Link, useParams, useNavigate } from "react-router-dom";
import styles from "./AssinarChecklist.module.css";
import { useEffect, useState } from "react";
import { assinar, checarToken } from "../../api/assinatura.api";
import { toast } from "react-toastify";

function AssinarChecklist() {
    const { tipo, token } = useParams()

    const navigate = useNavigate()

    const [confirmaCodigo, setConfirmaCodigo] = useState(false)
    const [codigo, setCodigo] = useState("");
    const [dataAss, setDataAss] = useState({})
    const [termo, setTermo] = useState("");

    function gerarTermo(data) {
        if (!data) return "";

        let termo = `Eu, ${data.nome}, declaro para os devidos fins que estive presente na realização do checklist efetuado em ${data.data}, às ${data.hora}, referente ao veículo de modelo ${data.car?.nome}, placa ${data.car?.placa}, que se encontra sob minha responsabilidade no momento da inspeção.

        Estou ciente de todos os itens avaliados, bem como das condições encontradas durante a vistoria.

        Reconheço e concordo com as informações registradas, incluindo eventuais não conformidades ou problemas identificados, assumindo ciência integral do conteúdo apresentado.<br>`;

        if (data.itens?.length > 0) {
            data.itens.forEach(item => {
                termo += `<br>${item.item}: ${item.descricao ?? "Sem descrição"}`;
            });
        }

        termo += `<br><br>A presente confirmação eletrônica equivale à minha assinatura, para todos os efeitos legais.<br>`;

        return termo;
    }

    useEffect(() => {
        if (!token) {
            navigate("/notfound");
            return;
        }

        checarToken(token)
            .then((res) => {
                setDataAss(res.data);
                setTermo(gerarTermo(res.data));
            })
            .catch((err) => {
                console.log(err.response)
                navigate("/notfound")
            })
    }, [token, navigate])

    function AssinarChecklistHandler() {
        assinar(token, {
            Codigo: codigo,
            TermoDeCiencia: termo
        })
            .then((res) => {
                navigate(`/success/${token}`)
            })
            .catch(err => toast.error("Não foi possível assinar o checklist"))
    }

    return (
        <main className={styles.container}>
            <header className={styles.header}>
                <div>
                    <Car color="white" size={22} />
                </div>
                <p>Rapid Frota</p>
            </header>

            {confirmaCodigo === false ?
                <section className={styles.content}>
                    <p dangerouslySetInnerHTML={{ __html: termo }}> 
                    </p>

                    <div className={styles.assinatura}>
                        <p>{dataAss.nome}</p>

                        <button
                            className={styles.button}
                            onClick={() => setConfirmaCodigo(true)}
                        >
                            Assinar Checklist
                        </button>
                    </div>
                </section>
                :
                <section className={styles.contentConfirmar}>
                    <p>
                        Para prosseguir com a assinatura, digite o código de verificação (OTP) enviado para o seu e-mail.
                        Este código é pessoal, intransferível e possui validade limitada por motivos de segurança.
                    </p>

                    <input
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        pattern="[0-9]{6}"
                        required
                        onChange={(e) => setCodigo(e.target.value)}
                    />

                    <button
                        className={styles.button}
                        onClick={AssinarChecklistHandler}
                    >
                        Assinar Checklist
                    </button>
                </section>
            }
        </main>
    )
}

export default AssinarChecklist;